import { render } from "./QuickpayDownloadDocument.vue?vue&type=template&id=03199a20&scoped=true"
import script from "./QuickpayDownloadDocument.vue?vue&type=script&lang=js"
export * from "./QuickpayDownloadDocument.vue?vue&type=script&lang=js"

import "./QuickpayDownloadDocument.vue?vue&type=style&index=0&id=03199a20&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03199a20"]])

export default __exports__